/*eslint no-unused-expressions: [2, { allowTernary: true }]*/
import React, {
  useEffect,
  useState,
  useRef
} from 'react';
import { Link } from "react-router-dom";
import { Layout, Card, Row, Col, Spin, Input} from 'antd';
import { Button } from "reactstrap";
import { ProgressBar, PlaybackControls } from './ProgressBar';
import VideoLane from './LaneVideo';
import VideoAnnotated from './AnnotatedVideo';
import './sceneExtract.css';
import useAnimationFrame from './hooks/useAnimationFrame';
import { fetchTimestamps } from "./UserFunctions";
import SceneExtractNavbar from './sceneExtractNavbar';

const { Content } = Layout;
const gridStyle = (width, height) => ({
  width,
  height,
});


export default function SceneProfiling() {
  // states
  const [isPlaying, setIsPlaying] = useState(false);
  const [loading] = useState(false);
  const [loadingTip] = useState('Loading...');
  const [value, setValue] = useState(0);
  const [duration, setDuration] = useState(0);
  const timeline = useRef([0]);
  const currentTimeRef = useRef(0);
  const [currentTime, setCurrentTime] = useState(0);
  const isPlayingRef = useRef(false);
  const isLaneVideoSeeking =useRef(false);
  const isVDVideoSeeking =useRef(false);

  const handlePlay = () => {
    if (timeline.current.length > 1) {
      isPlayingRef.current = true;
      setIsPlaying(true);
    }
  };
  const handlePause = () => {
    isPlayingRef.current = false;
    setIsPlaying(false);
  };

  const handleChange = (val) => {
    currentTimeRef.current = val;
    setValue(timeline.current[currentTimeRef.current]);
  };
  
  const onLaneVideoSeek = () => {
    isLaneVideoSeeking.current = false;
  }; 

  const onVDVideoSeek = () => {
    isVDVideoSeeking.current = false;
  }; 

  useEffect(() => {
    fetchTimestamps(`${window.location.origin}/get_timestamps`).then( (response) => {
            if(response && response.status === 200) {
                timeline.current = response.data.data
                setDuration(timeline.current.length);
            }
    })
  },[]);

  useEffect(() => {
    setCurrentTime(currentTimeRef.current);
  },[value, isPlaying]);

const renderScreen = (deltaTime) => {
    if (isPlayingRef.current && !isLaneVideoSeeking.current && !isVDVideoSeeking.current) {
      currentTimeRef.current += 1;
      isLaneVideoSeeking.current = true;
      isVDVideoSeeking.current = true;
      if (timeline.current.length - 1 === currentTimeRef.current) {
        setIsPlaying(false);
        isPlayingRef.current = false;
      }
      setValue(timeline.current[currentTimeRef.current]);
    }
  };
  // export default function SceneProfiling() {
  //   // states
  //   const [isPlaying, setIsPlaying] = useState(false);
  //   const [loading] = useState(false);
  //   const [loadingTip] = useState('Loading...');
  //   const [value, setValue] = useState(0);
  //   const [duration, setDuration] = useState(0);
  //   const timeline = useRef([0]);
  //   const currentTimeRef = useRef(0);
  //   const [currentTime, setCurrentTime] = useState(0);
  //   const isPlayingRef = useRef(false);
  //   const isLaneVideoSeeking =useRef(false);
  //   const isVDVideoSeeking =useRef(false);
  
  //   const handlePlay = () => {
  //     if (timeline.current.length > 1) {
  //       isPlayingRef.current = true;
  //       setIsPlaying(true);
  //     }
  //   };
  //   const handlePause = () => {
  //     isPlayingRef.current = false;
  //     setIsPlaying(false);
  //   };
  
  //   const handleChange = (val) => {
  //     currentTimeRef.current = val;
  //     setValue(timeline.current[currentTimeRef.current]);
  //   };
    
  //   const onLaneVideoSeek = () => {
  //     isLaneVideoSeeking.current = false;
  //   }; 
  
  //   const onVDVideoSeek = () => {
  //     isVDVideoSeeking.current = false;
  //   }; 
  
  //   useEffect(() => {
  //     fetchTimestamps(`${window.location.origin}/get_timestamps`).then( (response) => {
  //             if(response && response.status === 200) {
  //                 timeline.current = response.data.data
  //                 setDuration(timeline.current.length);
  //             }
  //     })
  //   },[]);
  
  //   useEffect(() => {
  //     setCurrentTime(currentTimeRef.current);
  //   },[value, isPlaying]);
  
  // const renderScreen = (deltaTime) => {
  //     if (isPlayingRef.current && !isLaneVideoSeeking.current && !isVDVideoSeeking.current) {
  //       currentTimeRef.current += 1;
  //       isLaneVideoSeeking.current = true;
  //       isVDVideoSeeking.current = true;
  //       if (timeline.current.length - 1 === currentTimeRef.current) {
  //         setIsPlaying(false);
  //         isPlayingRef.current = false;
  //       }
  //       setValue(timeline.current[currentTimeRef.current]);
  //     }
  //   };
  
  
useAnimationFrame(renderScreen);

  // update progress bar regularly

  return (
    <Spin data-test = 'sceneExtractSceneProfilingComponent' spinning={loading} tip={loadingTip}>
      <SceneExtractNavbar />
      <Layout>
        <div className="row">
        <div className="col-lg-12" style = {{backgroundColor: 'white'}}>
        <Content style={{ display: 'flex' }}>
          <div
              className="row"
              style={{
                height: '8vh',
                width: '100%',
                backgroundColor: '#ffffff',
                marginLeft: 'unset',
                marginBottom: '10px',
                padding: 0,
              }}
            >
            <Card className= "col-12" size="small" title="Scene Profiling" style={{ height: '8vh',width: '100%', border: '2px solid #aaa',textAlign: 'center',padding: '0px',backgroundColor: '#ffffff' }} />
            </div>
          </Content>
          <Content style={{ display: 'flex' }}>
          <div
              className="row"
              style={{
                height: '8vh',
                width: '100%',
                backgroundColor: '#ffffff',
                marginLeft: 'unset',
                padding: 0,
              }}
            >
            <Card className= "col-6" size="small" title="Lane Profile" style={{ height: '8vh', border: '2px solid #aaa',textAlign: 'center',padding: '0px',backgroundColor: '#ffffff' }} />
            <Card className= "col-6" size="small" title="Traffic Profile" style={{ height: '8vh', border: '2px solid #aaa',textAlign: 'center',padding: '0px',backgroundColor: '#ffffff' }} />
            </div>
          </Content>
          <Layout style={{  display: 'flex', flexDirection: 'column',height: '60vh',overflowY: 'hidden' }}>
          <Content style={{ display: 'flex' }}>
            <div
              style={{
                height: '50vh',
                width: '50%',
                backgroundColor: '#ffffff',
                padding: 0,
              }}
            >
              <div
                style={{
                  ...gridStyle('100%', '100%'),
                  border: '2px solid #aaa',
                  borderRight: 'none',
                  padding: '0px',
                }}
              >
                <VideoLane 
                  time={value}
                  onSeek={onLaneVideoSeek}
                 />
              </div>
            </div>
            <div
              style={{
                height: '50vh',
                width: '50%',
                backgroundColor: '#ffffff',
                padding: 0,
              }}
            >
              <div
                style={{
                  ...gridStyle('100%', '100%'),
                  border: '2px solid #aaa',
                  borderRight: 'none',
                  padding: '0px',
                }}
              >
                <VideoAnnotated 
                  time={value}
                  onSeek={onVDVideoSeek}
                 />
              </div>
            </div>
          </Content>
          <Card style={gridStyle('100%', '10vh')}>
            <Row align="middle">
              <Col>
                <Input
                  value={value}
                  defaultValue="0.000"
                  disabled
                  style={{ width: '100px' }}
                />
              </Col>
              <Col>
                <PlaybackControls
                  isPlaying={isPlaying}
                  onPlaybackChange={(playing) => {
                    if (playing) {
                      handlePlay();
                    } else {
                      handlePause();
                    }
                  }}
                />
              </Col>
              <Col flex={20}>
                <ProgressBar
                  value={currentTime}
                  onChange={(val) => {
                    setCurrentTime(val);
                    handleChange(val);
                  }}
                  step={1}
                  max={duration}
                />
              </Col>
            </Row>
          </Card>
        </Layout>
        <Content style={{ display: 'flex',backgroundColor:"white",marginBottom:'10px',marginTop: '10px' }}>  
        <div
                style={{
                  ...gridStyle('25%', '10%'),
                  borderRight: 'none',
                  marginLeft: 'unset',
                  padding: '0px',
                }}
              ></div>  
        <div
                style={{
                  ...gridStyle('75%', '10%'),
                  borderRight: 'none',
                  align:'center',
                  marginLeft: 'unset',
                  padding: '0px',
                }}
              >
              <Link
                      to="/digital_twin"
                      style={{ textDecoration: "none" }}
               >
               <Button
                 style={{
                  border: '2px solid #aaa',
                  backgroundColor:"blue",
                  color: "#white",
                  fontSize: 'bold',
                  cursor: 'pointer',
                  width: "67%"
                 }}
                >
                  Digital Twin
                </Button>
                </Link>
              </div>
              </Content>
          <Layout style={{  display: 'flex', flexDirection: 'column',height: '7vh',overflowY: 'hidden' }}>
          <Content style={{ display: 'flex',backgroundColor:"white" }}>
          <div
                style={{
                  ...gridStyle('25%', '10%'),
                  borderRight: 'none',
                  marginLeft: 'unset',
                  padding: '0px',
                }}
              ></div>  
        <div
                style={{
                  ...gridStyle('75%', '10%'),
                  borderRight: 'none',
                  align:'center',
                  marginLeft: 'unset',
                  padding: '0px',
                }}
              >
               <Button
                 style={{
                  border: '2px solid #aaa',
                  backgroundColor:"blue",
                  color: "white",
                  fontSize: "bold",
                  cursor: 'pointer',
                  width: "67%"
                 }}
                 onClick={handlePause}
                 href="http://10.30.12.104:7000/honda/index/"
                 target="_blank"
                >
                  Profiler Tool(Annotation)
                </Button>
              </div>
          </Content>
          </Layout>
              </div>
        </div>
      </Layout>
    </Spin>
  );
}

